import { recommendedComparator } from '@components/Sorting/Provider';
import { createBestItineraryData } from './createBestItineraryData';

const RecommendedItineraryBuilder = () => {
  let recommendedPosition;
  let recommended = {
    meRating: -Infinity,
  };

  return {
    add(itinerary, position) {
      if (recommendedComparator(itinerary, recommended) < 0) {
        recommended = itinerary;
        recommendedPosition = position;
      }
    },
    build() {
      return createBestItineraryData(
        'recommended',
        recommended,
        recommendedPosition
      );
    },
  };
};

export default RecommendedItineraryBuilder;
